import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import GLogo from '../../assets/images/g-logo.png';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isLogin: boolean;
};

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 20,
    height: 20,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(),
    border: `1px solid ${theme.palette.grey[400]}`,
  },
  grow: {
    width: 10,
  },
}));

export default function GoogleButton({ onClick, disabled, isLogin }: Props) {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      className={classes.container}
      startIcon={<img src={GLogo} className={classes.logo} alt="google" />}
    >
      {isLogin ? 'Log In with Google' : 'Sign Up with Google'}
      <div className={classes.grow} />
    </Button>
  );
}
